import { computed, type ComputedRef } from 'vue'

import { useRbac } from '@/features/account'

const HEALTH_CHECKS_PERMISSION = 'configuration_control'

export interface UseHealthChecksRbac {
  canView: ComputedRef<boolean>
}

/**
 * Feature-owned RBAC seam for Health Checks.
 *
 * The server-provided account permission remains the single authority. Keeping
 * this predicate behind one computed value lets the page, nav visibility and
 * route metadata share the same fail-closed decision during account boot.
 */
export function useHealthChecksRbac(): UseHealthChecksRbac {
  const { hasPermission } = useRbac()

  return {
    canView: computed(() => hasPermission(HEALTH_CHECKS_PERMISSION)),
  }
}
